import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetCustomerTableData: '[GetCustomerTableData] Action',
  GetProjectInfoData: '[GetProjectInfoData] Action',
  GetAppliedScriptData: '[GetAppliedScriptData] Action',
  GetServerStatusData: '[GetServerStatusData] Action',
  GetMobiSyncVersion: '[GetMobiSyncVersion] Action',
  SetCustomerData: '[SetCustomerData] Action',
  GetJournalTranslateData: '[GetJournalTranslateData] Action', 
  GetTestJournalTranslateData: '[GetTestJournalTranslateData] Action', 
  GetSettingsTranslateData: '[GetSettingsTranslateData] Action', 
  GetLogsTranslateData: '[GetLogsTranslateData] Action', 
  GetAppliedTranslateData: '[GetAppliedTranslateData] Action', 
  GetAppliableTranslateData: '[GetAppliableTranslateData] Action', 
}

const initialCompanyState: ICompanyState = {
  customer: undefined,
  erp: [],
  partners: [],
  company: undefined,
  companyMother: undefined,
  companyDaughters: [],
  companySisters: [],
  serverStatus: 0,
  groupOptions: [],
  systemOptions: [],
  projectMOptions: [],
  deviceOptions: [],
  statusOptions: [],
  docsPath: [],
  interfaceTypeOptions: [],
  nbScriptFaild: [],
  nbXmlFaild: [],
  mobiSync: [],
  settingColumnList: [],
  settingColumnValues: [],
  settingDefinitions: [],
  settingDe: [],
  settingEn: [],

  journalColumnList: [],
  journalColumnValues: [],
  journalDefinitions: [],
  journalDe: [],
  journalEn: [],

  logColumnList: [],
  logColumnValues: [],
  logDefinitions: [],
  logDe: [],
  logEn: [],

  testJournalColumnList: [],
  testJournalColumnValues: [],
  testJournalDefinitions: [],
  testJournalDe: [],
  testJournalEn: [],

  appliedColumnList: [],
  appliedColumnValues: [],
  appliedDefinitions: [],
  appliedDe: [],
  appliedEn: [],

  appliableColumnList: [],
  appliableColumnValues: [],
  appliableDefinitions: [],
  appliableDe: [],
  appliableEn: [],
}

export interface ICompanyState {
  customer: any,
  erp: [],
  partners: [],
  company: any,
  companyMother: any,
  companyDaughters: [],
  companySisters: [],
  serverStatus: number,
  groupOptions: [],
  systemOptions: [],
  projectMOptions: [],
  deviceOptions: [],
  statusOptions: [],
  docsPath: [],
  interfaceTypeOptions: [],
  nbScriptFaild: [],
  nbXmlFaild: [],
  mobiSync: [],
  
  settingColumnList: [],
  settingColumnValues: [],
  settingDefinitions: [],
  settingDe: [],
  settingEn: [],

  journalColumnList: [],
  journalColumnValues: [],
  journalDefinitions: [],
  journalDe: [],
  journalEn: [],

  logColumnList: [],
  logColumnValues: [],
  logDefinitions: [],
  logDe: [],
  logEn: [],

  testJournalColumnList: [],
  testJournalColumnValues: [],
  testJournalDefinitions: [],
  testJournalDe: [],
  testJournalEn: [],

  appliedColumnList: [],
  appliedColumnValues: [],
  appliedDefinitions: [],
  appliedDe: [],
  appliedEn: [],

  appliableColumnList: [],
  appliableColumnValues: [],
  appliableDefinitions: [],
  appliableDe: [],
  appliableEn: [],
}

export const reducer = persistReducer(
  { storage, key: 'portal-customer', whitelist: [] },
  (state: ICompanyState = initialCompanyState, action: any) => {
    switch (action.type) {
      case actionTypes.GetCustomerTableData: {
        const customer = action.payload.data.customer;
        const company = JSON.parse(action.payload.data.company);
        const companyDaughters = JSON.parse(action.payload.data.companyDaughters);
        const companySisters = JSON.parse(action.payload.data.companySisters);
        let companyMother = null;
        if (action.payload.data.companyMother) {
          companyMother = JSON.parse(action.payload.data.companyMother);
        }
        const erp = JSON.parse(action.payload.data.erp);
        const partners = JSON.parse(action.payload.data.partners);
        const groupOptions = JSON.parse(action.payload.data.groupOptions);
        const systemOptions = JSON.parse(action.payload.data.systemOptions);
        const projectMOptions = JSON.parse(action.payload.data.projectMOptions);
        const deviceOptions = JSON.parse(action.payload.data.deviceOptions);
        const statusOptions = JSON.parse(action.payload.data.statusOptions);
        const serverStatus = action.payload.data.serverStatus;
        const settingColumnValues = action.payload.data.advancedSettings;
        let headers = JSON.parse(action.payload.data.headers);
        let settingDefinitions = JSON.parse(action.payload.data.definitions);
        let settingColumnList: any = [];

        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          settingColumnList.push(newElement[0]);
        });
        const docsPath = action.payload.data.docPaths;

        const logColumnValues = JSON.parse(action.payload.data.errorLogs);
        let logHeaders = JSON.parse(action.payload.data.logHeaders);
        let logDefinitions = JSON.parse(action.payload.data.logDefinitions);
        let logColumnList: any = [];

        logHeaders.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          logColumnList.push(newElement[0]);
        });

        const testJournalColumnValues = JSON.parse(action.payload.data.testJournal);
        let testJournalHeaders = JSON.parse(action.payload.data.journalHeaders);
        let testJournalDefinitions = JSON.parse(action.payload.data.journalDefinitions);
        let testJournalColumnList: any = [];

        testJournalHeaders.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          testJournalColumnList.push(newElement[0]);
        });

        return { ...state, customer, company, companyDaughters,companySisters, companyMother, erp, partners, serverStatus, groupOptions, systemOptions, projectMOptions, deviceOptions, statusOptions, docsPath, settingColumnList, settingColumnValues, settingDefinitions, logColumnValues, logDefinitions, logColumnList, testJournalColumnValues, testJournalDefinitions, testJournalColumnList };
      }
      case actionTypes.GetServerStatusData: {
        const serverStatus = action.payload.data.serverStatus;
        const testJournalColumnValues = JSON.parse(action.payload.data.testJournal);
        return { ...state, serverStatus,testJournalColumnValues};
      }
      case actionTypes.GetProjectInfoData: {
        const customer = action.payload.data.customer;
        const company = JSON.parse(action.payload.data.company);
        const interfaceTypeOptions = JSON.parse(action.payload.data.interfaceTypeOptions);
        const nbScriptFaild = action.payload.data.nbScriptFaild;
        const nbXmlFaild = action.payload.data.nbXmlFaild;
        const mobiSync = action.payload.data.mobiSync;

        const journalColumnValues = action.payload.data.journal;
        let headers = JSON.parse(action.payload.data.headers);
        let journalDefinitions = JSON.parse(action.payload.data.definitions);
        let journalColumnList: any = [];

        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          journalColumnList.push(newElement[0]);
        });

        return { ...state, customer, company, interfaceTypeOptions, nbScriptFaild, nbXmlFaild, mobiSync, journalColumnValues, journalDefinitions, journalColumnList};
      }
      case actionTypes.GetMobiSyncVersion: {
        const mobiSync = action.payload.data.mobiSync;
        return { ...state, mobiSync};
      }
      case actionTypes.GetAppliedScriptData: {
        const appliedColumnValues = action.payload.data.appliedScripts;
        let headers = JSON.parse(action.payload.data.headers);
        let appliedDefinitions = JSON.parse(action.payload.data.definitions);
        let appliedColumnList: any = [];

        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          appliedColumnList.push(newElement[0]);
        });

        const appliableColumnValues = action.payload.data.appliableScripts;
        let scriptheaders = JSON.parse(action.payload.data.scriptHeaders);
        let appliableDefinitions = JSON.parse(action.payload.data.scriptDefinitions);
        let appliableColumnList: any = [];

        scriptheaders.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          appliableColumnList.push(newElement[0]);
        });

        return { ...state,appliedColumnValues, appliedDefinitions, appliedColumnList, appliableColumnList, appliableColumnValues, appliableDefinitions};
      }

      case actionTypes.SetCustomerData: {
        const customer = action.payload.data.customer;
        const serverStatus = action.payload.data.serverStatus;
        const testJournalColumnValues : any = [];
       
        return { ...state, customer, serverStatus, testJournalColumnValues};
      }

      case actionTypes.GetJournalTranslateData: {
        const journalDe = JSON.parse(action.payload.data.de);
        const journalEn = JSON.parse(action.payload.data.en);
        return { ...state, journalDe, journalEn };
      }
      case actionTypes.GetSettingsTranslateData: {
        const settingDe = JSON.parse(action.payload.data.de);
        const settingEn = JSON.parse(action.payload.data.en);
        return { ...state, settingDe, settingEn };
      }
      case actionTypes.GetLogsTranslateData: {
        const logDe = JSON.parse(action.payload.data.de);
        const logEn = JSON.parse(action.payload.data.en);
        return { ...state, logDe, logEn };
      }
      case actionTypes.GetAppliedTranslateData: {
        const appliedDe = JSON.parse(action.payload.data.de);
        const appliedEn = JSON.parse(action.payload.data.en);
        return { ...state, appliedDe, appliedEn };
      }
      case actionTypes.GetTestJournalTranslateData: {
        const testJournalDe = JSON.parse(action.payload.data.de);
        const testJournalEn = JSON.parse(action.payload.data.en);
        return { ...state, testJournalDe, testJournalEn };
      }
      case actionTypes.GetAppliableTranslateData: {
        const appliableDe = JSON.parse(action.payload.data.de);
        const appliableEn = JSON.parse(action.payload.data.en);
        return { ...state, appliableDe, appliableEn };
      }

      default:
        return state
    }
  }
)

export const actions = {
  getCustomerTableData: (data: any) => ({ type: actionTypes.GetCustomerTableData, payload: { data } }),
  setCustomerData: (data: any) => ({ type: actionTypes.SetCustomerData, payload: { data } }),
  getProjectInfoData: (data: any) => ({ type: actionTypes.GetProjectInfoData, payload: { data } }),
  getMobiSyncVersion: (data: any) => ({ type: actionTypes.GetMobiSyncVersion, payload: { data } }),
  getServerStatusData: (data: any) => ({ type: actionTypes.GetServerStatusData, payload: { data } }),
  getAppliedScriptData: (data: any) => ({ type: actionTypes.GetAppliedScriptData, payload: { data } }),
  getJournalTranslateData: (data: any) => ({ type: actionTypes.GetJournalTranslateData, payload: { data } }),
  getSettingsTranslateData: (data: any) => ({ type: actionTypes.GetSettingsTranslateData, payload: { data } }),
  getLogsTranslateData: (data: any) => ({ type: actionTypes.GetLogsTranslateData, payload: { data } }),
  getTestJournalTranslateData: (data: any) => ({ type: actionTypes.GetTestJournalTranslateData, payload: { data } }),
  getAppliedTranslateData: (data: any) => ({ type: actionTypes.GetAppliedTranslateData, payload: { data } }),
  getAppliableTranslateData: (data: any) => ({ type: actionTypes.GetAppliableTranslateData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
